export default __webpack_public_path__ + "origami_logo.66b66510.svg";